<template>
  <esg-base-dashboard-card id="EsgPartnerCorpMonitoringProgressManagementGrid"
                           title="협력사 상세정보">
    <b-container fluid class="mt-2">
      <esg-table-without-meta :fields="fields"
                              :items="getItem"
                              class="mb-2"
                              size="sm">
        <template #thead-top>
          <tr>
            <th colspan="3"
                class="text-align-center"><span>협력사 정보</span></th>
            <th colspan="5"><span>제출관리</span></th>
          </tr>
        </template>
        <template #cell(file)="data">
          <td class="text-center">
            <img v-if="data.item.file !== ''"
                 class="fit-picture"
                 src="@/components/esg/images/excel.png"
                 alt="Grapefruit slice atop a pile of other slices"
                 style="height:1.5em;"/>
          </td>
        </template>
      </esg-table-without-meta>
    </b-container>
  </esg-base-dashboard-card>
</template>
<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import EsgTableWithoutMeta from "@/components/esg/base/EsgTableWithoutMeta.vue";

export default {
  props: ['gridId'],
  components: {
    EsgTableWithoutMeta,
    EsgBaseDashboardCard
  },
  data() {
    return {
      businessLoc: 'all',
      status: 'all',
      loading: false,
      items: [
        [
          {
            id: "2022-001",
            corpName: "EY 컨설팅",
            businessLocation: "울산 고무공장",
            reqDate: '2023-03-05',
            dueDate: '2023-04-05',
            submitDate: '-',
            status: '미제출',
            file: 'test'
          },
          {
            id: "2022-002",
            corpName: "EY 한영",
            businessLocation: "당진 고무공장",
            reqDate: '2023-03-05',
            dueDate: '2023-04-05',
            submitDate: '-',
            status: '미제출',
            file: 'test'
          },
          {
            id: "2022-003",
            corpName: "EY 세무",
            businessLocation: "울산 고무공장",
            reqDate: '2023-03-05',
            dueDate: '2023-04-05',
            submitDate: '-',
            status: '미제출',
            file: 'test'
          },
          {
            id: "2022-004",
            corpName: "EY KDS",
            businessLocation: "당진 고무공장",
            reqDate: '2023-03-05',
            dueDate: '2023-04-05',
            submitDate: '-',
            status: '미제출',
            file: 'test'
          },
          {
            id: "2022-005",
            corpName: "EY 정공",
            businessLocation: "당진 고무공장",
            reqDate: '2023-03-05',
            dueDate: '2023-04-05',
            submitDate: '2023-03-12',
            status: '제출완료',
            file: 'test'
          },
          {
            id: "2022-006",
            corpName: "EY 운송",
            businessLocation: "당진 고무공장",
            reqDate: '2023-03-05',
            dueDate: '2023-04-05',
            submitDate: '2023-04-03',
            status: '제출완료',
            file: 'test'
          },
          {
            id: "2022-007",
            corpName: "EY GDS",
            businessLocation: "당진 고무공장",
            reqDate: '2023-03-05',
            dueDate: '2023-04-05',
            submitDate: '2023-03-22',
            status: '제출완료',
            file: 'test'
          }
        ],
      ],
    }
  },
  created() {
  },
  computed: {
    corpOptions() {
      return Array.from(new Set(this.items[0].map(item => item.corpName)));
    },
    bizLocOptions() {
      return Array.from(new Set(this.items[0].map(item => item.businessLocation)));
    },
    statusOptions() {
      return Array.from(new Set(this.items[0].map(item => item.status)));
    },
    getItem() {
      return this.items[this.gridId];
    },
    fields() {
      let fieldSet = [];
      switch (this.gridId) {
        case 0:
          fieldSet = [
            {
              name: "id",
              label: "관리번호",
              list: true,
              thClass: ["text-center"],
              tdClass: ["text-center", "align-middle"],
              sortable: true
            },
            {
              name: "corpName",
              label: "협력사명",
              list: true,
              thClass: ["text-center"],
              tdClass: ["text-center", "align-middle"]
            },
            {
              name: "businessLocation",
              label: "주거래 사업장",
              list: true,
              sortable: true,
              thClass: ["text-center"],
              tdClass: ["text-center", "align-middle"]
            },
            {
              name: "reqDate",
              label: "요청일",
              list: true,
              thClass: ["text-center"],
              tdClass: ["text-center", "align-middle"],
              sortable: true
            },
            {
              name: "dueDate",
              label: "마감일",
              list: true,
              thClass: ["text-center"],
              tdClass: ["text-center", "align-middle"],
              sortable: true
            },
            {
              name: "submitDate",
              label: "제출일",
              sortable: true,
              list: true,
              thClass: ["text-center"],
              tdClass: ["text-center", "align-middle"],
            },
            {
              name: "status",
              label: "진행상황",
              list: true,
              thClass: ["text-center"],
              tdClass: ["text-center", "align-middle"],
            },
            {
              name: "file",
              label: "파일",
              list: true,
              thClass: ["text-center"],
              tdClass: ["text-center", "align-middle"]
            }
          ]
          break;
      }
      return fieldSet;
    }
  },
  methods: {},
}
</script>
<style scoped>
>>> * {
  font-family: NanumGothic;
}

#EsgPartnerCorpMonitoringProgressManagementGrid {
  margin-top: 1em;
  padding: 0;
}

#EsgPartnerCorpMonitoringProgressManagementGrid >>> .table-wrapper {
  overflow-x: scroll;
  white-space: nowrap;
  width: 100%;
}

#EsgPartnerCorpMonitoringProgressManagementGrid >>> .table-wrapper table {
  width: auto;
  min-width: 100%;
}
</style>